import { PrismaClient } from "@prisma/client";
import { j as json } from "../../../../../chunks/index.js";
const prisma = new PrismaClient();
const DELETE = async ({ params }) => {
  const { id } = params;
  try {
    await prisma.brand.delete({
      where: { id }
    });
    return json({ message: "Brand deleted" });
  } catch (error) {
    console.error("Error deleting brand:", error);
    return json({ message: "Brand not found or could not be deleted" }, { status: 404 });
  }
};
export {
  DELETE
};
